
import { IsBoolean, IsNotEmpty, IsOptional } from 'class-validator';
import {
	IsAfter
} from '../../../../decorators';
import {
	UpdateEventV2Dto
} from './update-event-v2.dto';

export class CreateEventV2Dto extends UpdateEventV2Dto {
	@IsAfter('now')
	@IsNotEmpty({
		message: 'Start date should not be empty',
	})
	public override startDate?: Date;

	@IsOptional()
	@IsBoolean()
	public isCommunityChatSharingEnabled?: boolean;
}
